module.exports = __webpack_public_path__ + "img/reduxlogo.9601824b.png";